<template>
  <div class="TuanPay">
    <van-cell class="paymsg">
      <!-- 使用 title 插槽来自定义标题 -->
      <template slot="title">
        <h4>商品信息</h4>
      </template>
      <template slot="label">
        <span class="label">{{theItem.lessonName}}</span>
      </template>
      <template>
        <span class="price">¥{{theItem.priceAct|formatMoney}}</span>
      </template>
    </van-cell>
    <van-cell>
      <!-- 使用 title 插槽来自定义标题 -->
      <template slot="title">
        <h4>小计：</h4>
      </template>
      <template>
        <span class="grey">共计1件商品</span>
        <span class="price">¥{{theItem.priceAct|formatMoney}}</span>
      </template>
    </van-cell>
    <div class="fixed">
      <div class="flexbox">
        <div class="msg">
          应支付
          <span class="price">¥{{theItem.priceAct|formatMoney}}</span>
        </div>
        <van-button type="primary" class="orange-fault" @click="toPay()">提交订单</van-button>
      </div>
    </div>
  </div>
</template>
<script>
// import timeCounterSinple from '@/components/timeCounterSinple';
export default {
  name: 'TuanSuccess',
  // components: { timeCounterSinple },
  data() {
    return {
      ActiveShowForm: {
        name: '杭州教育艺术培训中心',
        title: '暑假班拼团，送福利！课程拼团仅需100元，大福利就来了',
        endTime: '2019-06-20',
        className: '',
        classDesc: '',
        classImg: [],
        originPrice: '688',
        groupPrice: '100',
        teamNum: '3',
        topNum: '20',
        activeDesc: '',
        rewardDesc: '',
        QrImg: [],
        ruleText: '',
        ruleImg: [],
        ruleVideo: [],
        phone: '',
        regList: [1, 2],
        eventName: '团购抢好课'
      },
      theItem: {
        headImgList: [],
        id: '',
        joinId: '',
        lessonName: '',
        priceAct: 0,
        restNum: 0,
        teamNum: 0
      },
      show: false,
      wx: 1
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    // this.getList();
    // if (this.$route.query.id) {
    //   this.getActiveShowForm();
    // }
    if (this.$route.query.joinId) {
      this.getJoinTeam();
    }
    // /activity/lesson/getJoinTeam
  },
  methods: {
    async getJoinTeam() {
      try {
        this.loading = true;
        let result = await this.$store.dispatch('getData', {
          url: '/activity/lesson/getJoinTeam',
          data: {
            joinId: this.$route.query.joinId
          },
          urltitle: '/show'
        });
        // console.log(this.dataCheckList);
        this.theItem = result;
      } catch (e) {
        this.$error(e.message);
      }
    },
    toPay() {
      this.go('/Activity/TuanSuccess');
    }
  }
};
</script>
<style lang="less" scoped>
.TuanPay {
  background: #fff;
  .paymsg {
    align-items: flex-end;
    h4 {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 15px;
    }
    .label {
      font-size: 14px;
      color: #333;
    }
  }
  .price {
    color: #ff8939;
    margin-left: 10px;
    font-size: 15px;
  }
  .fixed {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    height: 72px;
    background: #fff;
    border-top: 1px solid rgba(238, 238, 238, 1);
    .flexbox {
      height: 100%;
      padding: 0 15px;
      display: flex;
      align-items: center;
      .msg {
        font-size: 12px;
        color: #999999;
        flex: 1;
      }
    }
  }
}
</style>
